import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-learn-intro',
  templateUrl: './learn-intro.component.html',
  styleUrls: ['./learn-intro.component.scss'],
  standalone: false
})
export class LearnIntroComponent {
  
  @Output() finished: EventEmitter<any> = new EventEmitter<any>();

  stepIndex: number = 0;

  handlePrevClick() {
    if (this.stepIndex > 0) {
      this.stepIndex--;
    }
  }

  handleNextClick() {
    if (this.stepIndex < 2) {
      this.stepIndex++;
    } else {
      this.finished.emit();
    }
  }
}